<!-- 公众号注册用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">注册时间</div>
				<dateRangePicker :date_width="300" :before_number="0"
				@onGetDate="onGetDate"></dateRangePicker>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">渠道</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择渠道"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					showSearch
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.channel_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				
				<moreSelect
				 ref="getGzhSelect"
				:placeholder="'请选择公众号'"
				:select_mode="''"
				@handleChangeSelect="handleChangeB"
				></moreSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">用户ID</div>
				<a-input v-model="r_user_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">用户Openid</div>
				<a-input v-model="r_openid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<!-- <a-select-option value="toutiao">头条</a-select-option>
					<a-select-option value="baidu">百度</a-select-option> -->
					<a-select-option v-for="(value,key) in tgptSelect" :key="key" :value="key">{{value}}</a-select-option>
				</a-select>
			</div>
			

			<div class="screen-box">
				<div class="screen-label">推广计划ID</div>
				<a-input v-model="r_plan_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广创意ID</div>
				<a-input v-model="r_creative_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量项目ID</div>
				<a-input v-model="r_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量广告ID</div>
				<a-input v-model="r_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeC" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(item,index) in rableTitle" name="item.type">
						<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
						:style="{'width':rableTitle[index].width + 'px'}" >
							{{rableTitle[index].title}}
						</div>
					</template>
				</div>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'province' && z_tem.type != 'user_agent' && z_tem.type != 'match_type' && z_tem.type != 'has_report' && z_tem.type != 'report_id' && z_tem.type != 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'province'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}} {{item.county}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'user_agent'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<a-popover placement="top">
						<template slot="content">
						  <p style="width: 320px;word-break: break-word;">{{item[z_tem.type]}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item[z_tem.type]}}
						</div>
					</a-popover>
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'match_type'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | matchTypeFilter}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'has_report'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | hasReportFilter}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'report_id'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] || ""}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-show="item.has_report == 0" @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;">手动回传</div>					<!-- <div v-show="item.has_report == '否' && !item.plan_id" @click="HcTdTable(item,1)" style="color: #62a8ea;cursor: pointer;">自定义回传</div> -->
				</div>
			</template>
		</div>
		
		<!-- 表格内容为空时显示 -->
		<tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putDataMenu, regGzhList,  orderGzhCustomReport, regGzhReport, gzhChannelMedia } from '@/request/api'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
export default {
	name: 'registerGzh_',
	components: {moreSelect},
	data() {
		return {
			startTime: '2023-04-26', // 投放日期-开始时间
			endTime: '2023-04-24', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道", width:80, type:"channel_name", },
				{title:"公众号", width:100, type:"gzh_name", },
				{title:"注册时间", width:150, type:"reg_time", },
				{title:"用户ID", width:100, type:"user_id", },
				{title:"用户OpenId", width:160, type:"openid", },
				{title:"Unionid", width:160, type:"unionid", },
				{title:"IP", width:130, type:"user_ip", },
				{title:"IP所在地", width:130, type:"province", },
				{title:"UA", width:220, type:"user_agent", },
				
				{title:"落地页", width:100, type:"report_id_type", },
				{title:"落地页ID", width:100, type:"put_link_id", },
				{title:"推广平台", width:100, type:"report_platform", },
				{title:"推广计划ID", width:150, type:"plan_id", },
				{title:"推广创意ID", width:120, type:"creative_id", },
				{title:"巨量2.0项目ID", width:120, type:"project_id", },
				{title:"巨量2.0广告ID", width:120, type:"promotion_id", },
				{title:"落地页/点击表ID", width:120, type:"report_id", },
				{title:"匹配指标", width:120, type:"match_type", },
				{title:"是否回传", width:100, type:"has_report", },
				{title:"回传原因", width:120, type:"pass_reason", },
				{title:"回传时间", width:150, type:"report_time", },
				
				{title:"操作", width:160, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			sticky_index: 3,
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_channel_id: undefined, // 渠道id
			r_gzh_id: undefined, // 公众号id
			r_report_platform: undefined, // 媒体平台
			r_has_report: undefined, // 是否回传
			r_openid: null, // Openid
			r_plan_id: null, // 计划ID(单元ID)
			r_creative_id: null, // 创意ID
			r_user_id: null, // 用户ID
			r_ip: null, // 用户IP
			r_project_id: null, // 巨量项目ID
			r_promotion_id: null, // 巨量广告ID
			
			r_has_match: undefined, // 是否匹配点击。1为是。0为否
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			date_number: 7, // x天前的日期
			
			tgptSelect: {}, // 推广平台/媒体平台下拉
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 获取当天日期
		this.endTime = this.$getThisDay()
		this.startTime = this.$getThisDay()
		// 获取7天前的日期
		// this.startTime = this.$getBeforeDay(this.date_number)
		
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			// 公众号
			that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
			
			that.is_admin = res.data.data.is_admin
			
		})
		
		// 推广平台/媒体平台下拉
		gzhChannelMedia().then(res=>{
			console.log("推广平台/媒体平台下拉",res);
			that.tgptSelect = res.data.data.list
		})
		
		// 搜索
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onGetDate(date_start, date_end) {
			this.startTime = date_start
			this.endTime = date_end
		},
		handleChangeA(e){ // 渠道/书城
			console.log(e);
			this.r_channel_id = e
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeC(e){ // 是否回传
			console.log(e);
			this.r_has_report = e
			
		},
		handleChangeD(e){ // 媒体平台
			console.log(e);
			this.r_report_platform = e
		},
		handleChangeE(e){ // 是否匹配点击
			console.log(e);
			this.r_has_match = e
		},
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			regGzhList({
				export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				channel_id: that.r_channel_id, // 渠道id
				gzh_id: that.r_gzh_id, // 公众号id
				has_report: that.r_has_report, // 是否回传
				report_platform: that.r_report_platform, // 媒体平台
				openid: that.r_openid, // Openid
				plan_id: that.r_plan_id, // 计划ID(单元ID)
				creative_id: that.r_creative_id, // 创意ID
				
				user_id: that.r_user_id, // 用户ID
				user_ip: that.r_ip, // 用户IP
				project_id: that.r_project_id, // 巨量项目ID
				promotion_id: that.r_promotion_id, // 巨量广告ID
				
				has_match: that.r_has_match, // 是否匹配点击
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			regGzhReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		
	},
	filters: {
		matchTypeFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "未匹配"
			}
			else if(value == 1){
				mmm = "系统匹配"
			}
			else if(value == 2){
				mmm = "人工匹配"
			}
			else if(value == 3){
				mmm = "系统匹配：IP匹配"
			}
			else if(value == 4){
				mmm = "系统匹配：IP所在地匹配"
			}
			else if(value == 5){
				mmm = "系统匹配：设备ID匹配"
			}
			else if(value == 6){
				mmm = "用户注册表匹配"
			}
			return mmm
		},
		hasReportFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "不回传"
			}
			else if(value == 1){
				mmm = "已回传"
			}
			else if(value == -1){
				mmm = "未处理"
			}
			return mmm
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>